import { render, staticRenderFns } from "./ExamRecordCommon.vue?vue&type=template&id=d5da0bb6"
import script from "./ExamRecordCommon.vue?vue&type=script&lang=js"
export * from "./ExamRecordCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports